<template>
  <div class="section">
    <h3 class="section-title">{{ title }}</h3>
    <ul class="list">
      <li v-for="(item, idx) in items" :key="idx">{{ item }}</li>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  title: String,
  items: {
     type: [Array, String],
    default: () => []
  }
});
</script>

<style scoped>
.section {
  margin-bottom: 18px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 6px;
  font-weight: bold;
}

.list {
  margin-left: 15px;
}

.list li {
  margin-bottom: 4px;
}
</style>
